var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallSearchPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86744 9.75133C7.48369 11.0767 8.50493 12.1462 9.7676 12.7885C9.85999 12.8346 9.96218 12.8545 10.0641 12.8464C10.1661 12.8383 10.2642 12.8024 10.349 12.7422L12.2082 11.438C12.2904 11.3803 12.385 11.3451 12.4834 11.3356C12.5818 11.3261 12.6809 11.3426 12.7718 11.3835L16.25 12.9517C16.3681 13.0045 16.4668 13.0963 16.5311 13.2132C16.5953 13.3301 16.6217 13.4658 16.6063 13.5999C16.4964 14.5049 16.0767 15.3367 15.4257 15.9396C14.7748 16.5425 13.9373 16.8751 13.07 16.8751C10.3915 16.8751 7.8226 15.7557 5.92856 13.7631C4.03452 11.7706 2.97046 9.06806 2.97046 6.25014C2.9705 5.33777 3.28666 4.45671 3.85973 3.77192C4.4328 3.08712 5.22348 2.64556 6.08373 2.5299C6.21117 2.51368 6.34018 2.54146 6.45131 2.60908C6.56243 2.67669 6.64967 2.78046 6.69986 2.90476L8.19181 6.5671C8.2304 6.66183 8.24613 6.76513 8.23758 6.8678C8.22904 6.97047 8.1965 7.06932 8.14285 7.15556L6.9074 9.14147C6.85117 9.23081 6.81793 9.33396 6.81093 9.44085C6.80392 9.54775 6.82339 9.65472 6.86744 9.75133V9.75133Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSearchPhone);
export default __webpack_public_path__ + "static/media/CallSearchPhone.57252e88a8c761dc9e59806bdee52cf1.svg";
export { ForwardRef as ReactComponent };